export enum OwnershipChangeType {
  LEGACY = 'LEGACY',
  INITIAL = 'INITIAL',
  DIVESTMENT = 'DIVESTMENT',
  ACQUISITION = 'ACQUISITION',
}
export const ownershipChangeTypeToLabel: Record<OwnershipChangeType, string> = {
  [OwnershipChangeType.LEGACY]: 'Initial Setup',
  [OwnershipChangeType.INITIAL]: 'N/A – RWE % Share at Project Creation',
  [OwnershipChangeType.DIVESTMENT]: 'Divestment',
  [OwnershipChangeType.ACQUISITION]: 'Acquisition',
};
